import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import * as services from '@modules/real-property-toolbar/services';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subscription, of } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { ModalPhoneNumberComponent } from './components/modal-phone-number/modal-phone-number.component';

@Component({
  selector: 'app-real-property-toolbar',
  templateUrl: './real-property-toolbar.component.html',
  styleUrls: ['./real-property-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RealPropertyToolbarComponent implements OnDestroy {
  @Input() mode: 'vr' | 'hr' = 'vr';
  @Input() form: 'short' | 'normal' = 'normal';
  @Input() applicationId: number;
  @Input() realPropertyId: number;
  @Input() public likesCount: number;
  @Input() public readonly commentsCount: number;
  @Input() public inFavourites: boolean;

  private addRealPropertyToFavourites$: Subscription;
  private removeRealPropertyFromFavourites$: Subscription;

  private readonly addRealPropertyToFavouritesErrorMessage = 'Не удалось добавить в избранное';
  private readonly removeRealPropertyFromFavouritesErrorMessage = 'Не удалось удалить из избранного';

  constructor(
    private favouritesService: services.FavouritesManagementService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private _dialogService: DialogService,
  ) {}

  showPhoneNumberDialog() {
    this._dialogService.open(ModalPhoneNumberComponent, {
      showHeader: false,
    });
  }

  toggleLike() {
    this.inFavourites === true ? this.removeRealPropertyFromFavourites() : this.addRealObjectToFavourites();
  }

  public shareHandler() {
    window.navigator.share({ url: `/real-property/${this.applicationId}` });
  }

  private addRealObjectToFavourites() {
    this.inFavourites = true;
    this.addRealPropertyToFavourites$ = this.favouritesService
      .addRealPropertyObjectToFavourites(this.realPropertyId)
      .pipe(
        map((res) => (res && typeof res === 'number' ? res : this.messageService.add({ severity: 'error', summary: this.addRealPropertyToFavouritesErrorMessage }))),
        catchError((e, c) => {
          this.messageService.add({ severity: 'error', summary: this.addRealPropertyToFavouritesErrorMessage });
          return of(e, c);
        }),
        filter((likeCount) => likeCount !== null && typeof likeCount === 'number'),
        tap((likeCount) => {
          this.inFavourites = true;
          this.likesCount = likeCount;
          this.cdr.detectChanges();
        }),
      )
      .subscribe();
  }

  private removeRealPropertyFromFavourites() {
    this.inFavourites = false;
    this.removeRealPropertyFromFavourites$ = this.favouritesService
      .removeRealPropertyObjectFromFavouritesList(this.realPropertyId)
      .pipe(
        map((res) => (res && typeof res === 'number' ? res : this.messageService.add({ severity: 'error', summary: this.removeRealPropertyFromFavouritesErrorMessage }))),
        catchError((e, c) => {
          this.messageService.add({ severity: 'error', summary: this.removeRealPropertyFromFavouritesErrorMessage });
          return of(e, c);
        }),
        filter((likeCount) => likeCount !== null && typeof likeCount === 'number'),
        tap((likeCount) => {
          this.inFavourites = false;
          this.likesCount = likeCount;
          this.cdr.detectChanges();
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    if (this.addRealPropertyToFavourites$?.closed === false) {
      this.addRealPropertyToFavourites$.unsubscribe();
    }
    if (this.removeRealPropertyFromFavourites$?.closed === false) {
      this.removeRealPropertyFromFavourites$.unsubscribe();
    }
  }
}
